// 個別機能訓練に関する記録・詳細(Edit).
import * as React from 'react';
import * as PropTypes from 'prop-types';
import * as UserListField from '../constants/UserListField';
import * as KirokuConst from '../constants/Kiroku';
import KirokuModule from '../utils/KirokuModule';
import { JS_VOID, returnFalse } from '../utils/commonUtil';
import { convertTime, convertDay } from '../utils/dateUtil';
import { Global } from '../utils/global';

interface KirokuEditProps extends React.Props<{}> {
  moffAPIActions: any;
  user: UserListField.User;

  moffAPI: any;
}

interface KirokuEditState {
  checkDataArr: KirokuConst.CheckData[];

  // 保存ボタンの表示.
  displaySaveButton: boolean;
}

// 詳細本体.
export default class KirokuEdit extends React.Component<KirokuEditProps, KirokuEditState> {
  user: UserListField.User;

  static get contextTypes() {
    return {
      callbackParent: PropTypes.func,
    };
  }

  // inputタグのref.
  refDayNode: Map<number, HTMLInputElement| null>;
  refDurationNode: Map<number, HTMLInputElement | null>;
  refSubjectNode: Map<number, HTMLTextAreaElement | null>;
  refInstructorNode: Map<number, HTMLTextAreaElement | null>;
  refRemarksNode: Map<number, HTMLTextAreaElement | null>;

  // refから実際に入った値.
  dayValues: string[];
  durationValues: string[];
  subjectValues: string[];
  instructorValues: string[];
  remarksValues: string[];

  // 編集されたかチェック用.
  editChecks: boolean[];

  constructor(props: KirokuEditProps) {
    super(props);

    // 初期化.
    this.refDayNode = new Map<number, HTMLInputElement| null>();
    this.refDurationNode = new Map<number, HTMLInputElement | null>();
    this.refSubjectNode = new Map<number, HTMLTextAreaElement | null>();
    this.refInstructorNode = new Map<number, HTMLTextAreaElement | null>();
    this.refRemarksNode = new Map<number, HTMLTextAreaElement | null>();
  }

  componentWillMount() {
    this.user = this.props.user;

    // stateの準備.
    let tmp: KirokuConst.CheckData[] = [];

    this.props.moffAPI.result.filteredTraining.map((training: KirokuConst.Training, index: number) => {
      tmp.push({
        id: index,
        selected: true,
      } as KirokuConst.CheckData);
    });

    this.setState({
      checkDataArr: tmp,
      displaySaveButton: true
    });
  }

  componentWillReceiveProps() {
    this.refresh();
  }

  refresh() {
    // propsが変わった時に変化.
    // stateの準備.
    let tmp: KirokuConst.CheckData[] = [];

    this.props.moffAPI.result.filteredTraining.map((training: KirokuConst.Training, index: number) => {
      tmp.push({
        id: index,
        selected: true,
      } as KirokuConst.CheckData);
    });

    this.setState({
      checkDataArr: tmp,
    });
  }

  // チェックボックスの状況変更.
  changeSelection(id: number) {
    const nextState = this.state.checkDataArr.map(function (checkData: KirokuConst.CheckData) {
      return {
        id: checkData.id,
        selected: (checkData.id === id ? !checkData.selected : checkData.selected)
      };
    });
  
    this.setState({checkDataArr: nextState});
  }

  // <head>の共通処理.
  renderHead() {
    return (
      <thead>
        <tr>
          {!Global.isApp ?
            <th scope="col">印刷<br />対象</th>
          :
            <th scope="col" className="isApp" />
          }
          <th key={'date'} scope="col">実施日時</th>
          <th key={'time'} scope="col">実施時間</th>
          <th key={'trainingcontent'} scope="col">訓練内容</th>
          <th key={'featuretraining'} scope="col">機能訓練<br />指導員</th>
          <th key={'remark'} scope="col">特記事項</th>
        </tr>
      </thead>
    );
  }

  // 日付をコンバート.
  convertDay = (training: KirokuConst.Training): string => {
    let theday = convertTime(training.datetime).day;
    theday = convertDay(theday);
    return theday;
  }

  createChildComponent = (training: KirokuConst.Training, index: number) => (
    <tr
      key={`trainingedit_${index}`}
      className={this.state.checkDataArr[index].selected ? 'Print' : ''}
    >
      {!Global.isApp ?
        <td>
          <input
            type="checkbox"
            checked={this.state.checkDataArr[index].selected}
            onChange={this.changeSelection.bind(this, index)}
          />
        </td> : <td />
      }
      <td>
        {/* "項目追加"で追加時はこちら */}
        {/* 実施日時 */}
        {training.datetime.length < 20 ?
          <div>
            <input
              onChange={event => this.checkNodes()}
              type="datetime-local"
              required={true}
              ref={day => this.refDayNode.set(index, day)}
              defaultValue={training.datetimeT}
            /> 
          </div>
          :
          <div>
            {this.convertDay(training)}
            <input
              onChange={event => this.checkNodes()}
              type="hidden"
              ref={day => this.refDayNode.set(index, day)}
              defaultValue={training.day}
            />
          </div>
        }
      </td>
      <td>
        {/* 実施時間 */}
        <input
          onChange={event => this.checkNodes()}
          type="time"
          step="1"
          ref={duration => this.refDurationNode.set(index, duration)}
          defaultValue={training.duration}
        />
      </td>
      <td>
        {/* 訓練内容 */}
        <textarea
          onChange={event => this.checkNodes()}
          rows={2}
          cols={19}
          ref={subject => this.refSubjectNode.set(index, subject)}
          placeholder=""
          defaultValue={training.subject}
        />
      </td>
      <td>
        {/* 機能訓練 指導員 */}
        <textarea
          onChange={event => this.checkNodes()}
          rows={2}
          cols={8}
          ref={instructor => this.refInstructorNode.set(index, instructor)}
          placeholder=""
          defaultValue={training.instructor}
        />
      </td>
      <td>
        {/* 特記事項 */}
        <textarea
          onChange={event => this.checkNodes()}
          rows={2}
          cols={24}
          ref={remarks => this.refRemarksNode.set(index, remarks)}
          placeholder=""
          defaultValue={training.remarks}
        />
      </td>
    </tr>
  )

  // 「保存」ボタン押下時の処理.
  editHistory(e: React.FormEvent<HTMLFormElement>) {
    e.preventDefault();

    if (this.dayValues.length === 0) {
      alert('変更する項目がありません');
      return;
    }

    // 念のため5つがすべて同じlengthかをチェック.
    const len = [this.dayValues.length, this.durationValues.length, this.subjectValues.length,
      this.instructorValues.length, this.remarksValues.length].filter((x) => x === this.dayValues.length).length;

    if (len !== 5) {
      return;
    }

    // 新規用パラメータ.
    const postParams: KirokuConst.UpdateParamFormat[] = [];

    // 更新用パラメータ.
    const putParams: KirokuConst.UpdateParamFormat[] = [];
    const timeTexConvertedArr: string[] = [];

    const userId: string = this.props.user.user_id;

    for (let index: number = 0; index < this.dayValues.length; index++) {
      const dayValue: string = this.dayValues[index];
      let isNew: boolean = dayValue.includes('T');
      // 更新: 2018.03.08 19:00
      // 新規: 2018-03-09T11:47

      // 新規か更新を切り替える.
      if (isNew) {
        // New(新規)
        // 新規はdayでOK.
        const paramDatetime: string = `${this.dayValues[index].replace(/T/g, ' ')}:00`;

        // 実施時間が空なら時間を入れる.
        let duration = this.durationValues[index] || '00:00:00';

        const apiParams: KirokuConst.NewParamFormat = {
          // 新規の時だけ変換が必要
          'datetime': paramDatetime,
          'duration': duration,
          'subject': this.subjectValues[index],
          'instructor': this.instructorValues[index],
          'remarks': this.remarksValues[index],
        } as KirokuConst.NewParamFormat;
        postParams.push(apiParams);
      } else {
        // 変化があるかチェックする.
        if (!this.editChecks[index]) {
          // 変化がないなら何もしない.
          continue;
        }

        // Update(更新)
        const apiParams = {} as KirokuConst.UpdateParamFormat;

        // 値があるものだけ追加する.
        if (this.durationValues[index]) {
          apiParams.duration =  this.durationValues[index];
        }

        if (this.subjectValues[index]) {
          apiParams.subject = this.subjectValues[index];
        }

        if (this.instructorValues[index]) {
          apiParams.instructor = this.instructorValues[index];
        }

        if (this.remarksValues[index]) {
          apiParams.remarks = this.remarksValues[index];
        }

        putParams.push(apiParams);

        // 更新時はdayではなくdatetime.
        const datetime = this.props.moffAPI.result.filteredTraining[index].datetime;
        const timeTexConverted = convertTime(datetime);
        timeTexConvertedArr.push(timeTexConverted['ux-qa']);
      }
    }

    // NewとUpdateのAPI.
    this.props.moffAPIActions.postAndPutFunctionalTrainingHistory(userId, timeTexConvertedArr, postParams, putParams);

    // ボタン隠す.
    this.setState({
      displaySaveButton: false
    });
  }

  componentDidMount() {
    this.checkNodes();
  }

  componentDidUpdate() {
    this.checkNodes();

    // ボタン消えた状態は通信中.
    if (this.props.moffAPI.Loaded && this.state.displaySaveButton === false) { 
      alert('データを保存しました');
      KirokuModule.toKiroku(this);
    }
  }

  shouldComponentUpdate(nextProps: KirokuEditProps, nextState: KirokuEditState) {
    // ＜＞で月を移動したときに値を変化(this.props.moffAPIではなくnextPropsで行う).
    if (this.props.moffAPI.result.filteredTraining !== nextProps.moffAPI.result.filteredTraining) {
      if (nextProps.moffAPI.result.filteredTraining) {
        let tmp: KirokuConst.CheckData[] = [];
        nextProps.moffAPI.result.filteredTraining.map((training: KirokuConst.Training, index: number) => {
          tmp.push({
            id: index,
            selected: true,
          } as KirokuConst.CheckData);
        });
    
        this.setState({
          checkDataArr: tmp,
        });
      }
    }

    return true;
  }

  checkNodes() {
    this.dayValues = [];
    this.durationValues = [];
    this.subjectValues = [];
    this.instructorValues = [];
    this.remarksValues = [];

    // チェックリセット.
    // 実施時間, 訓練内容, 機能訓練指導員, 特記事項.
    // で1つでも変化があったらtrue.
    this.editChecks = new Array(this.refDayNode.size).fill(false);

    // 実施日時.
    Array.from(this.refDayNode.values())
        .filter(node => node != null)
        .forEach((node: any, i: number) => {
            if (node) {
              this.dayValues[i] = node.value;
            }
        });

    // 実施時間.
    Array.from(this.refDurationNode.values())
        .filter(node => node != null)
        .forEach((node: any, i: number) => {
            if (node) {
              this.durationValues[i] = node.value;
              this.editChecks[i] = this.editChecks[i] || (node.value !== node.defaultValue);
            }
        });

    // 訓練内容.
    Array.from(this.refSubjectNode.values())
        .filter(node => node != null)
        .forEach((node: any, i: number) => {
            if (node) {
              this.subjectValues[i] = node.value;
              this.editChecks[i] = this.editChecks[i] || (node.value !== node.defaultValue);
            }
        });

    // 機能訓練 指導員.
    Array.from(this.refInstructorNode.values())
        .filter(node => node != null)
        .forEach((node: any, i: number) => {
            if (node) {
              this.instructorValues[i] = node.value;
              this.editChecks[i] = this.editChecks[i] || (node.value !== node.defaultValue);
            }
        });

    // 特記事項.
    Array.from(this.refRemarksNode.values())
        .filter(node => node != null)
        .forEach((node: any, i: number) => {
            if (node) {
              this.remarksValues[i] = node.value;
              this.editChecks[i] = this.editChecks[i] || (node.value !== node.defaultValue);
            }
        });
  }

  /**
   * 存在してないときのrenderer.
   *
   * @returns
   * @memberof KirokuEdit
   */
  renderForZero() {
    return (
      <div>
        <p>この月はデータがありません。</p>
        <form onSubmit={e => this.editHistory(e)}>
          <table className="tblStyle00">
            {this.renderHead()}
            <tbody>
            {
              (null)
            }
            </tbody>
          </table>
          {this.state.displaySaveButton ? 
            <div className="edit-btn btnStyle00">
              <a
                href={JS_VOID}
                role="button"
                onClick={event => KirokuModule.addNewHistory(this, this.props.moffAPI.result.filteredTraining)}
              >
                項目追加
              </a>
            </div> : (null)
          }

          <div className="btn_wrap btn_group">
            {this.state.displaySaveButton ? 
              <div className="cancell-btn btnStyle00">
                <a
                  href={JS_VOID}
                  role="button"
                  onClick={event => this.toKirokuCancel()}
                >
                  キャンセル
                </a>
              </div> : (null)
            }

            {this.state.displaySaveButton ? 
              <div className="edit-btn btnStyle00">
                <button 
                  type="submit"
                  role="button"
                  name="action"
                  value="save"
                  onClick={returnFalse}
                  style={{cursor: 'pointer'}}
                >
                  保存する
                </button>
              </div> : (null)
            }
            {!this.state.displaySaveButton ? 
              <p>保存中</p> : (null)
            }
          </div>
        </form>
      </div>
    );
  }

  // キャンセルボタンの押下.
  toKirokuCancel() {
    KirokuModule.toKiroku(this);
  }

  /**
   *  存在しているときのrenderer.
   *
   * @returns
   * @memberof KirokuEdit
   */
  renderForExist() {
    return (
      <div>
        <form onSubmit={e => this.editHistory(e)}>
          <table className="tblStyle00">
            {this.renderHead()}
            <tbody>
            {
              this.state.checkDataArr.length > 0 ?
                this.props.moffAPI.result.filteredTraining.map((training: KirokuConst.Training, index: number) => {
                return this.createChildComponent(training, index);
              })
              :
              (null)
            }
            </tbody>
          </table>
          {this.state.displaySaveButton ? 
            <div className="edit-btn btnStyle00">
              <a
                href={JS_VOID}
                role="button"
                onClick={event => KirokuModule.addNewHistory(this, this.props.moffAPI.result.filteredTraining)}
              >
                項目追加
              </a>
            </div> : (null)
          }

          <div className="btn_wrap btn_group">
            {this.state.displaySaveButton ? 
              <div className="cancell-btn btnStyle00">
                <a
                  href={JS_VOID}
                  role="button"
                  onClick={event => this.toKirokuCancel()}
                >
                  キャンセル  
                </a>
              </div> : (null)
            }

            {this.state.displaySaveButton ? 
              <div className="edit-btn btnStyle00">
                <button type="submit" role="button" name="action" value="save">保存する</button>
              </div>
              : 
              <p>保存中</p>
            }
          </div>
        </form>
      </div>
    );
  }

  render() {
    let dataArrCount: number = 0;
    let trainingCount: number = 0;

    if (this.state.checkDataArr) {
      dataArrCount = this.state.checkDataArr.length;
    }

    if (this.props.moffAPI.result.filteredTraining) {
      trainingCount = this.props.moffAPI.result.filteredTraining.length;
    }

    return (
      (() => {
        // 0件、またはローディング中.
        if (dataArrCount === 0 || trainingCount === 0 || dataArrCount !== trainingCount || this.props.moffAPI.Loading) {
          return this.renderForZero();
        } else {
          return this.renderForExist();
        }
      })()
    );
  }
}



// WEBPACK FOOTER //
// ./src/components/KirokuEdit.tsx